import styled from 'styled-components';
export const Label = styled.div.withConfig({
  displayName: "FormattedCardPropertystyle__Label",
  componentId: "sc-156ymm5-0"
})(["font-size:12px;"]);
export const PropertyValue = styled.div.withConfig({
  displayName: "FormattedCardPropertystyle__PropertyValue",
  componentId: "sc-156ymm5-1"
})(["padding-bottom:15px;"]);